import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "./ui/button";

const BookDemo = ({
  variant = "default",
  size = "default",
  className = "",
  onClick = null,
}) => {
  const baseClasses =
    "bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-700 hover:to-cyan-600 text-white font-medium transition-all duration-300";

  const variants = {
    default: "px-4 sm:px-6 py-2 sm:py-3 rounded-lg text-sm sm:text-base",
    large: "px-6 sm:px-8 py-3 sm:py-4 rounded-xl text-base sm:text-lg",
    small: "px-3 sm:px-4 py-1.5 sm:py-2 rounded-md text-xs sm:text-sm",
  };

  const sizes = {
    default: "w-auto",
    full: "w-full",
  };

  const buttonClasses = `${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`;

  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    }
    // Default behavior - open Calendly
    window.open(
      "https://calendly.com/connect-solsphere/30min",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
      <Button onClick={handleClick} className={buttonClasses}>
        Book a Demo
        <ArrowRight className="w-3 sm:w-4 h-3 sm:h-4 ml-1 sm:ml-2" />
      </Button>
    </motion.div>
  );
};

export default BookDemo;
